import { Component, Input, SimpleChanges } from "@angular/core"
import { CardInfo, UserCardAssets } from "@app/shared/interfaces/user-card"

@Component({
  selector: "seb-wrapper-group-access-card",
  templateUrl: "./wrapper-group-access-card.component.html",
  styleUrls: ["./wrapper-group-access-card.component.css"],
})
export class WrapperGroupAccessCardComponent {
  @Input() cardList: CardInfo[]
  @Input() wrapperInfo: UserCardAssets

  showHeaderTemplateAfterSixCards(index, cardList) {
    // verifica se o resto da divisão do index por 6 é igual a 0 e se o index é diferente do tamanho do cardList
    // caso seja verdadeiro, o pdf iniciará em uma nova página com o header
    return (index + 1) % 6 === 0 && index !== cardList.length - 1
  }
  calculateMarginTop(index: number): number {
    const baseMargin = index >= 6 ? 218.9 : 230
    const additionalMargin = Math.floor(index / 6) * 0.08
    return baseMargin + additionalMargin
  }
}
